<template>
  <el-container>
    <el-header>
      <el-row style="border-bottom: 1px solid #e8e8e8">
        <el-col :span="3" style="text-align: left">
          <img src="@/assets/logo.jpg" style="height: 60px">
        </el-col>
        <el-col :span="17">
          <el-menu
            :default-active="activeTopMenu"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect">
            <el-menu-item index="first">
              <span>首页</span>
            </el-menu-item>
            <template v-for="(item, index) in menuListAll">
              <el-menu-item :index="item.navicatUuid" :key="item.navicatUuid">{{item.groupName}}</el-menu-item>
            </template>
            <el-menu-item v-show="switchValue">
              <div @click="onClickAddMenu('top')">
                <i v-show="switchValue" class="el-icon-plus"/>
              </div>
            </el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="4" style="line-height: 60px">
          <template v-if="!token">
            <el-button type="text" @click="onClickPreLogin">登录</el-button>
            <el-button type="text" @click="onClickPreRegist">注册</el-button>
          </template>
          <template v-else>
            <el-switch
                    v-model="switchValue"
                    @change="switchValueFn"
                    :width="20"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
            </el-switch>
            <el-button type="text" @click="onClickLogout">退出</el-button>
          </template>
        </el-col>
      </el-row>
    </el-header>

    <el-container>
      <el-aside width="200px" style="border-right: 1px solid #e8e8e8;" v-if="isIndexPage !=='first'">
        <el-menu :default-active="activeLeftMenu"
          class="el-menu-vertical-demo"
          @select="handleSelectLeft">
          <template v-for="(item, index) in menuListLeft">
            <el-menu-item :index="item.navicatUuid" :key="item.navicatUuid">{{item.groupName}}</el-menu-item>
          </template>
          <el-menu-item v-show="switchValue">
            <div @click="onClickAddMenu('left')">
              <i v-show="switchValue" class="el-icon-plus"/>
            </div>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main style="margin-left: -1px">
        <!-- 导航列表 -->
        <template v-if="isIndexPage==='first'">
          <el-table :data="innerList2"  border style="width: 100%" max-height="450">
            <template v-if="switchValue">
              <el-table-column label="加星" width="60" style="text-align: center">
                <template slot-scope="scope">
                  <i class="el-icon-star-on" style="font-size: 30px" @click="onClickStart(scope.row)"
                     v-if="scope.row.isStar"/>
                  <i class="el-icon-star-off" style="font-size: 30px" @click="onClickStart(scope.row)" v-else/>
                </template>
              </el-table-column>
            </template>

            <el-table-column label="地址名称" width="300" v-if="switchValue" >
              <template slot-scope="scope">
                <el-button type="text" @click="onClickDetail(scope.row)">{{scope.row.navicatUrlName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="地址名称" width="300" v-else>
              <template slot-scope="scope">
                <el-button type="text">{{scope.row.navicatUrlName}}</el-button>
              </template>

            </el-table-column>
            <el-table-column label="地址">
              <template slot-scope="scope">
                <el-button v-if="scope.row.url" @click="onClickButton(scope.row, 'url')">
                  {{scope.row.urlButtonName}}</el-button>
                <el-button v-if="scope.row.devUrl" @click="onClickButton(scope.row, 'devUrl')">{{scope.row.devUrlButtonName}}</el-button>
                <el-button v-if="scope.row.testUrl" @click="onClickButton(scope.row, 'testUrl')">{{scope.row.testUrlButtonName}}</el-button>
                <el-button v-if="scope.row.preUrl" @click="onClickButton(scope.row, 'preUrl')">{{scope.row.preUrlButtonName}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template v-else>
          <div style="padding-bottom: 8px; text-align: left">
            <el-button type="primary" @click="onClickAddList" v-show="switchValue">新增</el-button>
          </div>
          <el-table :data="innerList3" border style="width: 100%" max-height="450" row-key="navicatUrlUuid">
            <template v-if="switchValue">
              <el-table-column label="加星" width="60" style="text-align: center">
                <template slot-scope="scope">
                  <i class="el-icon-star-on" style="font-size: 30px" @click="onClickStart(scope.row)"
                     v-if="scope.row.isStar"/>
                  <i class="el-icon-star-off" style="font-size: 30px" @click="onClickStart(scope.row)" v-else/>
                </template>
              </el-table-column>
            </template>
            <el-table-column label="地址名称" width="300" v-if="switchValue" >
              <template slot-scope="scope">
                <el-button type="text" @click="onClickDetail(scope.row)">{{scope.row.navicatUrlName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="地址名称" width="300" v-else>
              <template slot-scope="scope">
                <el-button type="text">{{scope.row.navicatUrlName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="地址">
              <template slot-scope="scope">
                <el-button v-if="scope.row.url" @click="onClickButton(scope.row, 'url')">{{scope.row
                  .urlButtonName}}</el-button>
                <el-button v-if="scope.row.devUrl" @click="onClickButton(scope.row, 'devUrl')">{{scope.row.devUrlButtonName}}</el-button>
                <el-button v-if="scope.row.testUrl" @click="onClickButton(scope.row, 'testUrl')">{{scope.row.testUrlButtonName}}</el-button>
                <el-button v-if="scope.row.preUrl" @click="onClickButton(scope.row, 'preUrl')">{{scope.row.preUrlButtonName}}</el-button>
              </template>
            </el-table-column>
            <template v-if="switchValue">
              <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                  <i class="el-icon-delete" style="font-size: 30px" @click="onClickDelete(scope.row)"/>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </template>

        <!-- 注册与登录 -->
        <el-dialog :visible.sync="dialogTableVisible" :show-close="true">
          <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
            <el-form-item prop="userName" label="用户名" :rules="[{required: true, message: '请输入用户名', trigger: 'blur'},
             {message: '请输入正确的用户名', validator: validateUserName, trigger: ['blur','change']}]">
              <el-input v-model="dynamicValidateForm.userName"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码" :rules="[{required: true, message: '请输入密码', trigger: 'blur'},
             {message: '请输入正确的密码', validator: validatePassword, trigger: ['blur','change']}]">
              <el-input v-model="dynamicValidateForm.password" type="password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('submit')" @keyup.enter="submitForm('submit')">登录</el-button>
              <el-button @click="submitForm('register')">注册</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 添加导航分组 -->
        <el-dialog :visible.sync="dialogAddNavVisible" :show-close="true">
          <el-form :model="dialogAddNavForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
            <el-form-item prop="groupName" label="分组名称" :rules="[{required: true, message: '分组名称', trigger: 'blur'},
             {message: '请输入正确的分组名称', trigger: ['blur','change']}]">
              <el-input v-model="dialogAddNavForm.groupName"></el-input>
            </el-form-item>
            <el-form-item prop="draworder" label="显示顺序" :rules="[{required: true, message: '请输入显示顺序', trigger:
             'blur'},{message: '请输入正确的显示顺序', trigger: ['blur','change']}]">
              <el-input v-model="dialogAddNavForm.draworder" type="text" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入数字"></el-input>
            </el-form-item>
            <el-form-item prop="parentUuid" label="父节点" :rules="[{required: true, message: '请输入父节点', trigger: 'blur'},
             {message: '请输入正确的父节点', trigger: ['blur','change']}]">
              <el-input v-model="dialogAddNavForm.parentUuid" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitNavForm('submit')">提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 添加导航列表 -->
        <el-dialog :title="showDialogType === 1 ? '新增导航' : '编辑或查看导航'" :visible.sync="addListDialog" :show-close="true" :disabled="disableInputStatus">
          <el-form :model="addListDialogForm" ref="dynamicValidateForm" label-width="140px" class="demo-dynamic">
            <el-form-item label="导航地址名称" :rules="[{required: true, message: '导航地址名称', trigger: 'blur'},
             {message: '请输入正确的导航地址名称', trigger: ['blur','change']}]">
              <el-input v-model="addListDialogForm.navicatUrlName"></el-input>
            </el-form-item>
            <el-form-item label="导航分组UUID" :rules="[{required: true, message: '请输入导航分组UUID', trigger: 'blur'},
             {message: '请输入正确的导航分组UUID', trigger: ['blur','change']}]">
              <el-input v-model="addListDialogForm.navicatUuid" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="显示顺序" :rules="[{required: true, message: '请输入导航分组UUID', trigger:
             'blur'},{message: '请输入正确的显示顺序', trigger: ['blur','change']}]">
              <el-input v-model="addListDialogForm.draworder" type="text" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入数字"></el-input>
            </el-form-item>
            <el-form-item class="customeItem" label="主页" :rules="[{required: true, message: '请输入导航分组UUID', trigger:
            'blur'},
             {message: '请输入正确的主页地址', trigger: ['blur','change']}]">
              <el-col :span="24">
                <el-input v-model="addListDialogForm.url" placeholder="主页地址"/>
              </el-col>
              <el-col :span="24">
                <el-input v-model="addListDialogForm.urlButtonName" placeholder="主页按钮名称"/>
              </el-col>
              <el-col :span="24">
                <el-input v-model="addListDialogForm.urlAccount" placeholder="用户名"/>
              </el-col>
              <el-col :span="24">
                <el-input v-model="addListDialogForm.urlPwd" placeholder="密码" type="text"/>
              </el-col>
            </el-form-item>
            <template v-if="showMoreItem">
              <el-form-item label="开发" :rules="[{required: false, message: '请输入导航分组UUID', trigger:
            'blur'},
             {message: '请输入正确的开发地址', trigger: ['blur','change']}]">
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.devUrl" placeholder="开发地址"/>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.devUrlButtonName" placeholder="开发按钮名称"/>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.devUrlAccount" placeholder="用户名"/>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.devUrlPwd" placeholder="密码" type="text"/>
                </el-col>
              </el-form-item>
              <el-form-item label="测试" :rules="[{required: false, message: '请输入导航分组UUID', trigger: 'blur'},
             {message: '请输入正确的测试地址', trigger: ['blur','change']}]">
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.testUrl" placeholder="测试地址"/>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.testUrlButtonName" placeholder="测试按钮名称"/>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.testUrlAccount" placeholder="用户名"/>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.testUrlPwd" placeholder="密码" type="text"/>
                </el-col>
              </el-form-item>
              <el-form-item label="预上线" :rules="[{required: false, message: '请输入导航分组UUID', trigger: 'blur'},
             {message: '请输入正确的预上线地址', trigger: ['blur','change']}]">
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.preUrl" placeholder="预上线地址"/>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.preUrlButtonName" placeholder="预上线按钮名称"/>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.preUrlAccount" placeholder="用户名"/>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="addListDialogForm.preUrlPwd" placeholder="密码" type="text"/>
                </el-col>
              </el-form-item>
              <el-form-item>
                <el-button @click="onClickShowMore('up')" size="mini" icon="el-icon-arrow-up">隐藏更多</el-button>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item>
                <el-button @click="onClickShowMore('down')" size="mini" icon="el-icon-arrow-down">显示更多</el-button>
              </el-form-item>
            </template>
            <el-form-item>
              <el-button type="primary" v-show="switchValue" @click="onClickSubmitAddList('submit')">提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  export default {
    name: "Home",
    components: {},
    data () {
      return {
        isIndexPage: "first",
        activeTopMenu: "first",
        selectTopMenu: "",
        menuListAll: [],
        menuListLeft: [],
        activeLeftMenu: "",
        selectNavKey: "",
        switchValue: false, // 显示隐藏的按钮,
        dialogTableVisible: false,
        innerList2: [],
        heightList2: '420px',
        innerList3: [],
        dynamicValidateForm: {},
        dialogAddNavVisible: false,
        dialogAddNavForm: {},
        addListDialog: false,
        addListDialogForm: {},
        showDialogType: 1, // 1新增 2编辑 3查看
        showMoreItem: false
      }
    },
    mounted () {
      this.initPage();
    },
    computed: {
      ...mapState({
        token: state => state.token,
      }),
      disableInputStatus () {
        return this.showDialogType === 3
      }
    },
    created(){
      this.keyupSubmit()
    },
    methods: {
      keyupSubmit(){
        document.onkeydown = e =>{
          if (e.keyCode === 13) {
            this.submitForm('submit')
          }
        }
      },
      getElementHeight() {
        let innerHeight = window.innerHeight
        this.heightList2 = innerHeight * 0.9 + 'px'
      },
      initPage() {
        this.getElementHeight()
        this.getStartList()

        this.$post('/api/navicat/getnavicatgroup/', {}).then((response) => {
          let menuList = response.result
          if(menuList && menuList.length > 0){
            this.menuListAll = [...menuList]
          }

        }).catch(err=>{

        })
      },
      onClickIndexPage(){
        this.isIndexPage = "first"
        this.$nextTick(()=>{
          this.activeLeftMenu = ""
          this.selectNavKey = ""
        })
      },
      handleSelect(key, keyPath) {
        if(key === 'first'){
          this.onClickIndexPage()
        }else if(key){
          this.selectTopMenu = key
          this.isIndexPage = "second"
          let menuList = this.menuListAll.filter(item=> item.navicatUuid === key)
          let menuListLeft = []
          if(menuList && menuList.length > 0 && menuList[0].nodeList){
            menuListLeft = [...menuList[0].nodeList]
            this.menuListLeft = menuListLeft

            let navicatUuid = menuListLeft[0].navicatUuid

            this.handleSelectLeft(navicatUuid)
            this.$nextTick(()=>{
              this.activeLeftMenu = navicatUuid
              this.selectNavKey = navicatUuid
            })
          }
        }
      },
      handleSelectLeft(key, keyPath) {
        this.selectNavKey = key
        this.isIndexPage = "second"
        this.getNavList()
      },
      getNavList(){
        this.$post('/api/navicat/getnavicaturl/', {navicatUuid: this.selectNavKey}).then((response) => {
          this.innerList3 = response.result
        }).catch(err=>{
        })
      },
      getStartList(key, keyPath) {
        this.$post('/api/navicat/getstarnavicaturl/').then((response) => {
          this.innerList2 = response.result
        }).catch(err=>{
        })
      },
      switchValueFn(key, keyPath) {
        console.log(key, keyPath);
      },
      onClickPreRegist(){

      },
      onClickPreLogin(){
        this.dynamicValidateForm = {}
        this.dialogTableVisible = true
      },
      onClickLogout(){
        this.clearAllStore()
        this.dynamicValidateForm = {}
        this.initPage();
      },
      onClickAddList(){
        this.showDialogType = 1
        this.addListDialogForm = {
          navicatUuid: this.selectNavKey,
        }
        this.addListDialog = true
        this.showMoreItem = false
      },
      /**
       * 新增列表
       */
      onClickSubmitAddList(){
        let obj = {...this.addListDialogForm}
        if(!obj.navicatUrlName){ // 导航地址名称
          this.$message.warning("导航地址名称不能为空")
          return
        }
        if(!obj.url){ //
          this.$message.warning("主页URL不能为空")
          return
        }

        if(this.showDialogType === 1){ // 新增
          this.$post('/api/navicat/addnavicaturl/', obj).then((response) => {
            if(response && response.success){
              this.$message({
                message: "保存成功！",
                type: 'success'
              })
              this.addListDialog = false
              this.getNavList()
            }
          }).catch(err=>{
          })
        }else if(this.showDialogType === 2){ // 编辑
          this.$post('/api/navicat/updatenavicaturl/', obj).then((response) => {
            if(response && response.success){
              this.$message({
                message: "保存成功！",
                type: 'success'
              })
              this.addListDialog = false
              this.getNavList()
            }
          }).catch(err=>{
          })
        }
      },
      /**
       * 删除列表项
       */
      onClickDelete(record){
        let {navicatUrlUuid} = record
        if(navicatUrlUuid){
          this.$post('/api/navicat/deletenavicaturl/', {
            navicatUrlUuid
          }).then((response) => {
            if(response && response.success){
              this.$message({
                message: "删除成功！",
                type: 'success'
              })
              this.getNavList()
            }
          }).catch(err=>{
          })
        }
      },
      /**
       * 点击按钮
       */
      onClickButton(record, type){
        if(record && record[type]){
          window.open(record[type], '_blank')
        }
      },
      /**
       * 查看或编辑
       */
      onshowDetailInfo(record){
        if(this.switchValue){ // 可编辑
          this.showDialogType = 2
        }else{
          this.showDialogType = 3
        }
        this.addListDialogForm = record
        this.addListDialog = true
        this.showMoreItem = false
      },
      onClickDetail(record){
        this.$post('/api/navicat/getnavicaturldetails/', {
          navicatUrlUuid: record.navicatUrlUuid
        }).then((response) => {
          if(response && response.success){
            this.onshowDetailInfo(response.result)
          }
        }).catch(err=>{
        })
      },
      onClickShowMore(type){
        if(type === 'down'){
          this.showMoreItem = true
        }else{
          this.showMoreItem = false
        }
      },
      /**
       * 加星地址
       */
      onClickStart(record) {
        let {isStar, navicatUrlUuid} = record
        isStar = isStar ? 0 : 1
        this.$post('/api/navicat/navicaturlstar/', {
          navicatUrlUuid,
          isStar
        }).then((response) => {
          if(response && response.success){
            this.$message({
              message: "操作成功！",
              type: 'success'
            })
            this.getNavList()
          }
        }).catch(err=>{
        })
      },
      onClickAddMenu(type){
        this.dialogAddNavVisible = true
        let parentUuid = ""
        if(type==="top"){ //
          parentUuid = "0"
        }else{
          parentUuid = this.selectTopMenu
        }
        this.$set(this.dialogAddNavForm, 'parentUuid', parentUuid)
      },
      /**
       * 添加导航
       */
      submitNavForm() {
        let obj = {...this.dialogAddNavForm}
        this.$post('/api/navicat/addnavicatgroup/', obj).then((response) => {
          this.dialogAddNavVisible = false
        }).catch(err=>{
        })
      },
      validateUserName(rule, value, callback) {
        if (value === '') {
          callback(new Error('请输入用户名'));
        } else {
          callback();
        }
      },
      validatePassword(rule, value, callback) {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      },
      /**
       * 提交表单
       */
      submitForm(type) {
        let submitUrl = type === 'submit' ? '/api/navicat/login/' : '/api/navicat/register/'
        let {userName, password} = this.dynamicValidateForm
        let obj = {
          userName,
          password: this.$md5(password)
        }
        this.$post(submitUrl, obj).then((response) => {
          if(type === "submit"){
            let token = response.result
            this.setToken(token)
          }else{

          }
          this.$message.success("操作成功")
          this.initPage();
          this.$nextTick(()=>{
            this.dialogTableVisible = false
          })
        }).catch(err=>{
        })
      },
      ...mapMutations({
        setToken: 'setToken',
        clearAllStore: 'clearAllStore',
      })
    }
  };
</script>

<style>
  body /deep/ .el-container{
    height: 100%;
  }
  body /deep/ .el-container .el-container{
    padding-top: 7px;
  }
  body /deep/ .el-header{
    padding: 0;
  }
  body /deep/ .el-menu.el-menu-demo{
    height: 100%;
    border-bottom: 0;
  }
  body /deep/ .el-menu-vertical-demo{
    border: 0;
  }
</style>
